<template>
    <div class="step-items">
        <div class="step-item" v-for="(step, idx) in steps" :key="step.key" :class="{'step-item-active': step.key == active}">
            <div class="step-item-number">
                {{ idx + 1 }}
            </div>
            <div class="step-item-label">
                {{ step.lines[0] }}<br>
                {{ step.lines[1] }}
            </div>
        </div>
    </div>
</template>

<script>
import { wizardSteps } from './new-hires'

export default {
    props: {
        withNewHires: {type: Boolean, default: false},
        active: {type: String, required: true},
    },
    computed: {
        steps() {
            return wizardSteps(this.withNewHires)
        },
    },
}
</script>
